var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.25 9.25V4.32c0-.365-.145-.715-.403-.973l-1.944-1.944A1.376 1.376 0 0016.93 1H5.125c-.76 0-1.375.616-1.375 1.375V9.25A2.75 2.75 0 001 12v4.813c0 .38.308.687.688.687H3.75v4.125c0 .76.616 1.375 1.375 1.375h13.75c.76 0 1.375-.616 1.375-1.375V17.5h2.063c.38 0 .687-.308.687-.688V12a2.75 2.75 0 00-2.75-2.75zm-2.75 11h-11v-4.125h11v4.125zm0-9.625h-11V3.75h8.25v2.063c0 .38.308.687.688.687H17.5v4.125zm2.063 3.094a1.032 1.032 0 110-2.063 1.032 1.032 0 010 2.063z"
  }))));
}

export default SvgPrint;